import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from './../../../model/cliente/pageable/responsePageable.model';
import { TipoCaixaModel } from './../../../model/caixa/tipocaixa.model';
import { TipoCaixaService } from './../../../service/caixa/tipo-caixa.service';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-tipo-caixa',
  templateUrl: './tipo-caixa.component.html',
  styleUrls: ['./tipo-caixa.component.scss'],
})
export class TipoCaixaComponent implements OnInit {
  tipoCaixa = {} as TipoCaixaModel;
  tipoCaixas: TipoCaixaModel[];
  page: ResponsePageable;
  pageAtual = 0;
  submit = false;
  edited = false;
  editado = false;
  errorAlert = false;
  successDelete = false;
  messageError = false;
  mensagemDeErro = '';

  user: any;
  userAdmin = false;
  userUser = false;
  userEditor = false;
  userCreator = false;

  public arrayString: string;
  public creatorTpCaixa = false;
  public editorTpCaixa = false;
  public listaTpCaixa = false;
  public deletaTpCaixa = false;
  public superUser = false;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  @ViewChild('cardAdd') targetEl: ElementRef;

  constructor(private tipoCaixaService: TipoCaixaService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService) {}

  ngOnInit() {
    this.getTipoCaixa(0, 10);
    this.getAuthority();

  }

  changePage(event) {
    this.getTipoCaixa(event.page, event.size);
    this.pageAtual = event.page;
   }

  onSubmit() {
    this.submit = true;
  }

  postSubmit() {
    this.submit = false;
    this.tipoCaixa.id = undefined;
    this.tipoCaixa.descricao = null;
    this.tipoCaixa.cor = '#000000';
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  // Listar tipos de caixas
  getTipoCaixa(page: number, size: number) {
    this.tipoCaixaService.getTipoCaixas(page, size).subscribe(
      (data) => {
        this.page = data;
        this.tipoCaixas = this.page.content;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  putTipoCaixa() {
    this.tipoCaixaService.putTipoCaixa(this.tipoCaixa).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess('Tipo de Caixa editada com sucesso !');
      this.getTipoCaixa(0, 10);
    }, err => {
      console.log(err);
      this.openSnackBarError(`Erro ! ${this.mensagemDeErro}`);
    });
  }

  // Adicionar ou Editar tipo de Caixa
  manterTipoCaixa() {
    if (this.tipoCaixa.id !== undefined) {
      this.putTipoCaixa();
    } else {
      this.save();
    }
  }

  /*
  console.log(this.tipoCaixa);
  if (this.tipoCaixa.id !== undefined) {
    console.log(this.tipoCaixa);
    this.tipoCaixa = new TipoCaixaModel();
    this.getTipoCaixa(this.pageAtual, 10);
    this.postSubmit();
    this.openSnackBarSuccess('Tipo de Caixa atualizada com sucesso !');
  } else {*/

  save() {
    this.tipoCaixaService.postTipoCaixa(this.tipoCaixa).subscribe(
      (data) => {
        
          console.log(this.tipoCaixa);
          console.log(this.tipoCaixa.cor);
          if ((this.tipoCaixa.cor === null) || (this.tipoCaixa.cor === undefined)) {
            this.tipoCaixa.cor = '#000000';
            console.log(this.tipoCaixa);
          }
          this.tipoCaixa = new TipoCaixaModel();
          this.getTipoCaixa(0, 10);
          this.postSubmit();
          this.openSnackBarSuccess('Tipo de Caixa salva com sucesso !');
      },
      (error) => {
        console.error(error);
        this.mensagemDeErro = error.error.message;
        this.openSnackBarError(`Erro ! ${this.mensagemDeErro}`);
      }
    );
  }

  // Get dados do tipo de Caixa para editar
  getDados(tipoCaixa: TipoCaixaModel) {
    this.tipoCaixa = { ...tipoCaixa};
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorTpCaixa = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorTpCaixa = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaTpCaixa = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaTpCaixa = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // Alert Excluir Tipo De Caixa
  confirmeExcluir(id: number) {
    const confirme = confirm('Deseja excluir este Tipo de Caixa ?');
    if (confirme) {
      this.apagarTipoCaixa(id);
    } else {
      console.log('Cancelou exclusão');
    }
  }

  // Excluir Tipo De Caixa
  apagarTipoCaixa(id: number) {
    this.tipoCaixaService.deleteTipoCaixa(id).subscribe(() => {
      this.openSnackBarSuccess('Tipo de Caixa excluída com sucesso !');
      this.getTipoCaixa(0, 10);
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro ao excluir! Este Tipo de Caixa está sendo usado por uma caixa.');
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/tipo-caixa/tipo-caixa.component.ts